import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { CarModel } from 'models/StockModel';
import { AuthModel } from 'models/AuthModel';
import CarCardStatic from 'modules/cars/common/CarCardStatic';
import CompanyCard from 'modules/cars/cards/CompanyCard';
import CarCard from 'modules/cars/cards/CarCard';
import ExportCertCard from 'modules/cars/cards/ExportCertCard';
import DocumentsCard from 'modules/cars/cards/DocumentsCard';
import StatusButtonsCard from 'modules/cars/cards/StatusButtonsCard';
import ShippingCard from 'modules/cars/cards/ShippingCard';
import DestinationYardCard from 'modules/cars/cards/DestinationYardCard';
import PartiesCard from 'modules/cars/cards/PartiesCard';
import PhotoCard from 'modules/cars/cards/PhotoCard';
import YardCard from 'modules/cars/cards/YardCard';
import InnerCargoCard from 'modules/cars/cards/InnerCargoCard';
import InvoiceCard from 'modules/cars/cards/InvoiceCard';
import NotesCard from 'modules/cars/cards/NotesCard';
import { exportCertificateRequired } from 'modules/cars/utils/common';


type CarViewProps = {
    car: CarModel,
    my: AuthModel,
    title: ReactNode,
    canEdit: boolean,
}

const CarMobile = ({car, my, canEdit, title}: CarViewProps) => {
    return (
        <>
            <CompanyCard car={car}/>

            <StatusButtonsCard car={car}/>

            {my.permissions.has('cars update') && canEdit ?
                <CarCard key={`${car.id}${car.updatedAt}`} title={title} car={car}/> :
                <CarCardStatic title={title} car={car}/>
            }

            {exportCertificateRequired(car) && <ExportCertCard car={car}/>}

            <DocumentsCard car={car}/>

            <YardCard car={car}/>

            <ShippingCard car={car}/>

            <DestinationYardCard car={car}/>

            <PartiesCard partyableType="car" partyable={car}/>

            <PhotoCard car={car}/>

            <InnerCargoCard car={car}/>

            <InvoiceCard car={car}/>

            <NotesCard car={car}/>

            <Box height="64px"/>
        </>
    );
};

export default CarMobile;
